document.addEventListener("DOMContentLoaded", () => {
  const isDesktop = window.matchMedia("(min-width: 1280px)").matches;
  const featuredContent = document.querySelectorAll(
    ".featured-content.short-bg"
  );

  const featuredContentChecker = () => {
    if (isDesktop && featuredContent.length > 0) {
      featuredContent.forEach((item) => {
        const infoEl = item.querySelector(
          ".featured-content-main__infoWrapper"
        ) as HTMLElement;
        const imgEl = item.querySelector(
          ".featured-content-main__image img"
        ) as HTMLElement;
        if (infoEl && imgEl) {
          if (
            infoEl.clientHeight !== imgEl.clientHeight &&
            infoEl.clientHeight + 40 > imgEl.clientHeight
          ) {
            item.classList.add("hide-short-bg");
          }
        }
      });
    }
  };

  featuredContentChecker();

  const debounce = (func: Function) => {
    let timer: number;
    return function (event: Event) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(func, 100, event);
    };
  };

  // check again on window resize is done
  window.addEventListener(
    "resize",
    debounce(function (e: Event) {
      featuredContentChecker();
    })
  );
});
